/* eslint prefer-const: off */
import React, {
  useState,
  useEffect
} from 'react';
import { useTranslation}      from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '~/components/Button';
import ReceiptIcon from '@material-ui/icons/Receipt';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Request from '~/providers/Request';
import Dialog from '~/components/Dialog';

function DialogBillingStatus({ billing, handleClose }) {
  let [isLoading, setIsLoading] = useState(true);
  let [billingStatus, setBillingStatus] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    Request.get(`/admin/users/check_billing/${billing.id}`, {}, {normalizeJSON: false})
      .then( response => {
        setBillingStatus(response);
        setIsLoading(false);
      })
      .catch( e => {
        console.error(e);
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <Dialog
        icon={<ReceiptIcon />}
        isOpen
        handleClose={handleClose}
        title={t('planBilling.extras.transaction_data')}
        dialogActions={
          <Button onClick={handleClose} color='black' variant='text'>
            {t('close')}
          </Button>
        }
      >
        <div style={{minWidth: 680, width: '100%', textAlign: 'center'}}>
          { isLoading && <p>{t('planBilling.extras.loading')}</p> }
          { !isLoading &&
            <>
              <p><strong>{t('planBilling.extras.active_store')}:</strong> {billingStatus.exists ? 'SIM' : 'NÃO'}</p>
              <p><strong>{t('planBilling.extras.state_store')}:</strong> {billingStatus.autoRenew}</p>
              <p><strong>{t('planBilling.extras.validity_store')}:</strong> {billingStatus.validade}</p>
              <div style={{width: '100%'}}>
                <textarea style={{width: '100%'}} rows={40} defaultValue={ JSON.stringify(billingStatus.result, undefined, 4) }></textarea>
              </div>
            </>
          }
        </div>
      </Dialog>
    </>
  );
}

function DialogBillings({ user, handleClose }) {
  let [isLoading, setIsLoading] = useState(true);
  let [billings, setBillings] = useState([]);
  let [billingStatus, setBillingStatus] = useState(null);
  const { t } = useTranslation();
  const trAttr = (attr) => t(`planBilling.attributes.${attr}`);

  useEffect(() => {
    Request.get(`/admin/users/${user.id}/plan_billings`, {}, {normalizeJSON: false})
      .then( response => {
        setIsLoading(false);
        setBillings(response.data);
      })
      .catch( e => {
        console.error(e);
        setIsLoading(false);
      });

  }, []);

  return (
    <>
      { billingStatus && <DialogBillingStatus billing={billingStatus} handleClose={ () => setBillingStatus(null) } /> }
      <Dialog
        icon={<ReceiptIcon />}
        isOpen
        handleClose={handleClose}
        title={t('planBilling.extras.transactions')}
        dialogActions={
          <Button onClick={handleClose} color='black' variant='text'>
            {t('close')}
          </Button>
        }
      >
        <div style={{minWidth: 750, width: '100%', textAlign: 'center'}}>
          { isLoading && <p>{t('planBilling.extras.loading')}</p> }
          { !isLoading &&
            <table style={{width: '100%'}}>
              <thead>
                <tr>
                  <th>{trAttr('transaction_at')}</th>
                  <th>{trAttr('transaction_id')}</th>
                  <th>{trAttr('store')}</th>
                  <th>{trAttr('price')}</th>
                  <th>{trAttr('state')}</th>
                  <th>{trAttr('origin')}</th>
                  <th>{trAttr('check_status')}</th>
                </tr>
              </thead>
              <tbody>
                { billings.map( billing =>
                  <tr key={billing.id}>
                    <td>{billing.transaction_at}</td>
                    <td>{billing.transaction_id}</td>
                    <td>{billing.store}</td>
                    <td>{billing.price}</td>
                    <td>{billing.state}</td>
                    <td>{billing.origin}</td>
                    <td>
                      <Button
                        onClick={() => setBillingStatus(billing)}
                      >
                        <VisibilityIcon/>
                      </Button>
                    </td>
                  </tr>
                ) }
              </tbody>
            </table>
          }
        </div>
      </Dialog>
    </>
  );
}

DialogBillings.propTypes = {
  handleClose: PropTypes.func.isRequired,
  record: PropTypes.any,
};

export default React.memo(DialogBillings);
